<template>
	<div
		class="flex flex-listing widgets"
		v-if="toShow"
	>
		<div>
			<div class="shadow-box section-content" style="background: #ffe8e6">
				<h2>Le tue ricette</h2>
				<div class="chart mt-10">
					<pie-chart
						:src="percentArray"
					/>

					<div class="legend mt-10">
						<div
							v-for="part in percentArray"
						>
							<div class="inline circle" :style="`background-color: ${ part.color }`" />
							<span>{{ Math.round(part.percent) }}% {{ part.name }} </span>
						</div>
					</div>
				</div>
				<router-link :to="{ name: 'your-statistics' }" class="link-detail">
					Scopri di più
				</router-link>
			</div>		
		</div>

		<div>	
			<div class="shadow-box section-content" style="background: #ffff7f">
				<h2>Cene risolte</h2>
				<div class="counter-icon">
					<img src="../../assets/img/badges/widget/dish.png">
				</div>

				<div>

					<p class="text-center">
						Il numero di volte che hai scelto di cenare con Quomi
					</p>
					<div class="flex-column flex-center">
						<num-counter
							class="counter"
							:src="stats.meals"
						/>
						<p>cene</p>
					</div>
				</div>
			
				<router-link :to="{ name: 'your-statistics' }" class="link-detail">
					Scopri di più
				</router-link>
			</div>

		</div>	

		<div>
			<div class="shadow-box section-content" style="background: #aaffff">	

				<h2>CO<sub>2</sub> risparmiata</h2>		
				<div class="counter-icon">
					<img src="../../assets/img/badges/widget/eco.png">
				</div>
				<div class="counter-c">
					<p class="text-center">
						Le emissioni ridotte rispetto alla spesa al supermercato
					</p>
					<div class="flex-column flex-center">
						<num-counter
							class="counter"
							:src="stats.meals * 2"
						/>
						<p>kg</p>
					</div>
				</div>

				<router-link :to="{ name: 'your-statistics' }" class="link-detail">
					Scopri le statistiche
				</router-link>
				
			</div>
		
		</div>
			<div>
			<div class="shadow-box section-content" style="background: #d2fc6b">	

				<h2>Alberi piantati</h2>		
				<div class="counter-icon">
					<img src="https://api.quomi.it/oldimg/alberi-quomi-eden.webp">
				</div>
				<div class="counter-c">
					<p class="text-center">
						Il numero degli alberi che hai contribuito a far piantare
					</p>
					<div class="flex-column flex-center">
						<num-counter
							class="counter"
							:src="trees"
						/>
						<p>alberi</p>
					</div>
				</div>

				<router-link :to="{ name: 'edenTree' }" class="link-detail">
					Scopri il progetto
				</router-link>
				
			</div>
		
		</div>
	</div>
</template>

<script>

import PieChart from './PieChart'
import NumCounter from './NumCounter'

export default {
	components: {
		PieChart,
		NumCounter
	},

	computed: {
		toShow () {
			return this.user.stats && this.stats && this.user.stats.orders.count > 0
		},

		user () {
			return this.$root.user
		},

		stats () {
			return this.user.stats.orders
		},

		trees () {
			return this.user.stats.orders.trees
		},

		categories () {
			return this.stats.categoriesMerged
		},

		totalMealsInCategories () {
			var object = this.categories
			var total = 0

			Object.keys(object).map((key) => {
				var value = object[key]
				total += value.src
			})

			return total
		},

		percentArray () {
			var object = this.categories
			var array = []
			var colors = ['var(--quomi-green)', 'var(--quomi-orange)', 'var(--quomi-red)', 'var(--quomi-blue)', 'yellow']
			
			Object.keys(object).map((key, index) => {
				var value = object[key]
				let percent = value.src / this.totalMealsInCategories * 100
				if(this.user.stats.orders.meals == 0) {
					percent = 0
				}
				array.push({
					percent: percent,
					color: colors[index % colors.length],
					name: this.$t('components.widget.' + key)
				})
			})

			return array
		}
	}
}

</script>

<style scoped>
h2 {
font-size: 20px;
text-align: center;
}

.widgets > div {
	width: 33%;
	padding: 15px 20px;
}

.section-content {
	display: flex;
	flex-direction: column;
	padding: 25px;
}

.counter {
	font-size: 40px;
	color: var(--quomi-darkgrey);
	line-height: 1;
	text-align: right;
	font-weight: bold;
}

.counter + p {
	text-align: center;
	font-weight: bold;
	font-size: 20px;
}

.link-detail {
	text-align: center;
	width: 100%;
	display: block;
	margin-top: auto;
}

.widget-container {
	justify-content: space-between;
}

.counter-icon {
	margin: 40px auto;
	width: 100px;
	opacity: 0.7;
}

.circle {
	width: 10px;
	height: 10px;
	margin-right: 5px;
}

.legend {
	font-size: 13px;
	width: fit-content;
	margin: 0 auto;
	padding-bottom: 15px;
}

@media (min-width: 769px) and (max-width: 1240px) {
	.widgets {
		justify-content: center;
	}
	.widgets > div {
		flex-basis: calc(100%/2 - 20px);
	}
}

@media(max-width: 1240px) {
	.widgets {
		flex-wrap: wrap;
	}

	.widgets > div {
		width: 100%;
	}
}
</style>
